import classNames from "classnames";
import { ReactComponent as Email } from "../../assets/email.svg";
import { ReactComponent as Github } from "../../assets/github.svg";
import { ReactComponent as Linkedin } from "../../assets/linkedin.svg";

function SocialLinks({ className }) {
  return (
    <div
      className={classNames(
        "w-max h-max z-30 flex flex-col items-center",
        className
      )}
    >
      <a
        href="https://www.linkedin.com/in/rohan-sharma-323593202/"
        target="_blank"
        rel="noreferrer"
        title="LinkedIn"
        className="w-max h-max social-link mb-4 scale-110"
      >
        <Linkedin />
      </a>
      <a
        href="https://github.com/rohan843"
        target="_blank"
        rel="noreferrer"
        title="GitHub"
        className="w-max h-max social-link my-3 scale-110"
      >
        <Github />
      </a>
      <a
        href="mailto:rohan.sharma2934@gmail.com"
        title="Email"
        className="w-max h-max social-link mt-4 scale-110"
      >
        <Email />
      </a>
    </div>
  );
}

export default SocialLinks;
